import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ButtonComponent} from "../../../../core/components/api/button/button.component";
import {
    CommentSummaryFieldModule
} from "../../../../../../../modules/core/component/comment/comment-summary-field/comment-summary-field.component";
import {ItemModule} from "../../../../../../../modules/core/component/item/item.module";
import {
    LovValueSummaryFieldModule
} from "../../../../../../../modules/common/lov/lov-value/api/component/lov-value-summary-field/lov-value-summary-field.module";
import {SummaryFieldModule} from "../../../../../../../modules/core/component/summary-field/summary-field.module";
import {
    MedicalRecordSportSaveComponent,
    MedicalSportSaveDialogInput, MedicalSportSaveDialogResult
} from "../../../../../../../modules/medical/medical-record/sport/api/component/medical-record-sport-save/medical-record-sport-save.component";
import {
    MedicalRecordSportModel
} from "../../../../../../../modules/medical/medical-record/sport/api/model/medicalRecordSport.model";
import {DialogController} from "../../../../../../../modules/common/dialog/dialogController";
import {
    MedicalRecordSportSaveModule
} from "../../../../../../../modules/medical/medical-record/sport/api/component/medical-record-sport-save/medical-record-sport-save.module";
import {IconsModule} from "../../../../../../../../icons.module";
import {
    MedicalSportDeleteService
} from "../../../../../../../modules/medical/medical-record/sport/impl/service/medicalSportDelete.service";
import {SummaryModule} from "../../../../../../../modules/core/component/summary/summary.module";

@Component({
  selector: 'app-luna-consultation-sport-item',
  standalone: true,
    imports: [CommonModule, ButtonComponent, CommentSummaryFieldModule, ItemModule, LovValueSummaryFieldModule, SummaryFieldModule, MedicalRecordSportSaveModule, IconsModule, SummaryModule],
  templateUrl: './consultation-sport-item.component.html',
    providers: [
        MedicalSportDeleteService
    ]
})
export class ConsultationSportItemComponent {

    @Input() sport: MedicalRecordSportModel;

    constructor(private dialogController: DialogController,
                public deleteService: MedicalSportDeleteService) {}

    edit() {
        const input: MedicalSportSaveDialogInput = {
            id: this.sport.id
        };
        const dialog = this.dialogController.open(
            MedicalRecordSportSaveComponent,
            input, {
                title: 'Sport'
            });
        dialog.afterClosed().toPromise()
            .then((value: MedicalSportSaveDialogResult) => {
                if (value) {
                    this.sport = value.entity;
                }
            });
    }

}
